<template>
  <div class="_container">
    <div class="_header">
      <div class="header_title" v-text="$t('utils.offer_templates')" />
      <BaseButton
        icon="$mdiFileCog"
        type="primary"
        @click="importDialogOpen = true"
      >
        {{ $t("utils.create") }}
      </BaseButton>
    </div>
    <BaseDataTable
      :items="offerTemplates.items"
      :loading="loading"
      :options="{
        page: filters.page,
        itemsPerPage: filters.page_size,
      }"
      :server-items-length="offerTemplates.count"
      :loading-text="$t('utils.loadingData')"
      @update:options="onPaginationChange"
    >
      <template #header>
        <thead>
          <tr>
            <th>
              {{ $t("folder.offerName") }}
            </th>

            <th>
              {{ $tc("utils.type", 1) }}
            </th>

            <th>
              {{ $t("utils.dateCreated") }}
            </th>
            <th>
              {{ $t("utils.actions") }}
            </th>
          </tr>
        </thead>
      </template>
      <template #item="{ item }">
        <tr class="tab_row">
          <td>
            <div class="row_item">
              {{ item.title }}
            </div>
          </td>
          <td>
            <div class="row_item">
              {{ item.offerTypeLabel }}
            </div>
          </td>
          <td>
            <div class="row_item">
              {{ $d(new Date(item.dateCreated), "veryshort") }}
            </div>
          </td>
          <td>
            <div class="action_section">
              <BaseButtonIcon
                small
                color="primary"
                icon="$mdiPencilOutline"
                @click="editOfferTemplate(item.id)"
              />
            </div>
          </td>
        </tr>
      </template>
    </BaseDataTable>
    <offer-template-import-dialog
      v-if="importDialogOpen"
      :organization-id="organizationId"
      :offer-template-id="selectedOfferTemplateId"
      @close="onCloseTemplateImportDialog"
      @fetch-offer-templates="fetchOfferTemplates"
    />
  </div>
</template>

<script>
import OrganizationAPI from "@/core/Services/organization.api";
import OfferTemplateImportDialog from "../Components/OfferTemplateImportDialog.vue";
import { OfferTemplate } from "@/core/Models/OfferTemplate";
import { OFFER_TYPES } from "@/core/Utils/types.utils";
export default {
  name: "DocxTemplate",
  components: {
    OfferTemplateImportDialog,
  },
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      importDialogOpen: false,
      removeDialogOpen: false,
      selectedOfferTemplateId: null,
      offerTemplates: {
        items: [],
        count: 0,
      },
      loading: true,
      filters: {
        page_size: 10,
        page: 1,
      },
    };
  },
  created() {
    this.fetchOfferTemplates();
  },
  methods: {
    getOfferTypeLabel(offertype) {
      switch (offertype) {
        case OFFER_TYPES.SIGNATURE:
          return this.$t("folder.offer.signature");
        case OFFER_TYPES.VALIDATION:
          return this.$t("folder.offer.validation");
        default:
          return this.$t("folder.offer.consult");
      }
    },
    async fetchOfferTemplates() {
      this.loading = true;
      try {
        const response = await OrganizationAPI.getOrganizationOfferTemplate({
          organizationId: this.organizationId,
          filters: this.filters,
        });
        this.offerTemplates = {
          ...response.data,
          items: response.data.results.map((d) => ({
            ...new OfferTemplate(d),
            offerTypeLabel: this.getOfferTypeLabel(d.offerType),
          })),
        };
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.loading = false;
    },
    onPaginationChange(pagination) {
      this.filters.page = pagination.page;
      this.filters.page_size =
        pagination.itemsPerPage < 0
          ? this.offerTemplates.count
          : pagination.itemsPerPage;
      this.fetchOfferTemplates();
    },
    editOfferTemplate(item) {
      this.selectedOfferTemplateId = item;
      this.importDialogOpen = true;
    },
    onCloseTemplateImportDialog() {
      this.importDialogOpen = false;
      this.selectedOfferTemplateId = null;
    },
  },
};
</script>

<style scoped lang="scss">
._container {
  ._header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    gap: 16px;
    .header_title {
      font-weight: 600;
      font-size: 24px;
      line-height: 30px;
      color: #353542;
      margin-top: 8px;
      margin-right: auto;
    }
  }
  .tab_row {
    .row_item {
      padding: 16px 0;
      font-family: "Inter";
      font-style: normal;
      .item_label {
        color: #2536cc;
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .action_section {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
}
</style>
